<template>
  <div>

    <iMineTemplate :page-title="pageTitle" :actived-parent-key="activedParentKey" :actived-key="activedKey">
      <template #rightContent>
        <div class="memberCenter flex">
          <div class="top">
            <div class="middle pt30">
              <div class="headimg circle">
                <van-image
                  width="60px"
                  height="60px"
                  round
                  lazy-load
                  style="background: #FFFFFF;"
                  :src="CustomerInfo && CustomerInfo.Logo ? _getPic(CustomerInfo.Logo, true) : require('@/assets/mine/user.png')"
                  fit="scale-down"
                />
              </div>
              <div
                :class="
                  `headtag ${CustomerInfo &&
                    (CustomerInfo.FirstOrderStatus == '2'
                      ? 'headtag_success'
                      : CustomerInfo.FirstOrderStatus == '3'
                        ? 'headtag_error'
                        : CustomerInfo.FirstOrderStatus == '1'
                          ? 'headtag_waiting'
                          : 'headtag_warning')}`
                "
              />
            </div>
            <div class="username middle">{{ CustomerInfo ? _truncature(CustomerInfo.CustomerName, 7) : '' }}</div>
            <div class="service middle mt30 text-left">
              <van-row class="mt10" type="flex" justify="space-around">
                <van-col class="kf2 f12 fw400 text-center" span="7">专属客服</van-col>
                <van-col class="ellipsis-row1" span="5">{{ CustomerBusiness && CustomerBusiness.Name }}</van-col>
                <van-col span="10">{{ CustomerBusiness && CustomerBusiness.Phone }}</van-col>
              </van-row>
              <van-row class="mt10" type="flex" justify="space-around">
                <van-col class="kf1 f12 fw400 text-center" span="7">业务人员</van-col>
                <van-col class="ellipsis-row1" span="5">{{ CustomerService && CustomerService.Name }}</van-col>
                <van-col class="kf-phone" span="10">{{ CustomerService && CustomerService.Phone }}</van-col>
              </van-row>
            </div>
          </div>
          <div class="bottom">
            <van-row type="flex" class="mt70 text-left" justify="space-around">
              <van-col span="7" />
              <!-- <van-col span="4">
                <span class="fAkrobat">
                  <font class="f24">￥</font>234.09
                </span>
                <p class="ti flex align-items-center mt10">累计毛利</p>
              </van-col> -->
              <van-col
                span="3"
                style="cursor: pointer;"
                @click="
                  () => {
                    _jump(LinkTypeCode.MyCoupon);
                  }
                "
              >
                <span class="fAkrobat c222i">{{ CouponCount ? CouponCount : 0 }}</span>
                <p class="ti flex align-items-center mt10">
                  优惠券
                  <van-icon :name="require('@/assets/storey/in_gary.png')" size="14px" />
                </p>
              </van-col>
              <van-col
                span="3"
                style="cursor: pointer;"
                @click="
                  () => {
                    _jump(LinkTypeCode.AlwaysBuysList);
                  }
                "
              >
                <span class="fAkrobat c222i">{{ PurchasedGoodsCount ? PurchasedGoodsCount : 0 }}</span>
                <p class="ti flex align-items-center mt10">
                  常购商品
                  <van-icon :name="require('@/assets/storey/in_gary.png')" size="14px" />
                </p>
              </van-col>
              <van-col
                span="3"
                style="cursor: pointer;"
                @click="
                  () => {
                    _jump(LinkTypeCode.MyCollection);
                  }
                "
              >
                <span class="fAkrobat c222i">{{ MyFavouriteCount ? MyFavouriteCount : 0 }}</span>
                <p class="ti flex align-items-center mt10">
                  收藏商品
                  <van-icon :name="require('@/assets/storey/in_gary.png')" size="14px" />
                </p>
              </van-col>
            </van-row>
          </div>
        </div>
        <div class="pl20 flex mb20">
          <div class="order-list">
            <van-cell
              title="我的订单"
              title-class="f18 c222 text-left"
              class="pt20 pl20 pb20 pr20"
              center
              :border="false"
              value-class="flex align-items-center justify-content-flex-end cpointer"
            >
              <template>
                <router-link :to="{ name: LinkTypeCode.MyOrder }" tag="a" target="_blank">
                  <span class="c777 f14 mr6 ihover">查看全部</span>
                  <van-icon :name="require('@/assets/mine/right-arrow-icon.png')" size="14px" />
                </router-link>
              </template>
            </van-cell>
            <div class="pl20 pr20 bgfff pb30">
              <iOrderList
                v-if="orderDataList && orderDataList.length"
                :data="orderDataList"
                @handleConfirmGoods="handleConfirmGoods"
                @goApplyInvoice="goApplyInvoice"
                @cancelMoney="cancelMoney"
                @cancelOrder="cancelOrder"
                @goDetails="goDetails"
                @ViewLogistics="goViewLogistics"
                @lookApplyInvoice="lookApplyInvoice"
              />
            </div>
          </div>
        </div>
        <div class="pl20 flex mb20">
          <div class="order-list">
            <van-cell
              title="收藏的商品"
              title-class="f18 c222 text-left"
              class="pt20 pl20 pr20"
              :class="cDataList && cDataList.length ? 'pb0' : ''"
              center
              :border="false"
              value-class="flex align-items-center justify-content-flex-end cpointer "
              material
              theme
              u-i
            >
              <template>
                <router-link :to="{ name: LinkTypeCode.MyCollection }" tag="a" target="_blank">
                  <span class="c777 f14 mr6 ihover">查看全部</span>
                  <van-icon :name="require('@/assets/mine/right-arrow-icon.png')" size="14px" />
                </router-link>
              </template>
            </van-cell>
            <div v-if="cDataList && cDataList.length" class="bgfff mycollection ">
              <div class="goods">
                <div v-for="item in cDataList" :key="item.Id" class="goods-cell">
                  <div class="goods-b" @click.stop="showProduct(item)">
                    <div class="closeCollection" @click.stop="onCloseCollection(item)">取消收藏</div>
                    <iProductDetail :product="item" :goods-tags="item.GoodsTags" :activity-tags="item.ActivityTags" />
                  </div>
                </div>
              </div>

              <!-- <ProductListItem
								v-for="item in cDataList"
								:key="item.Id"
								:ref="'p_' + item.Id"
								:product="item"
								fromPage="MyCollection"
								goodsType="VGoods"
								@showProduct="showProduct(item)"
							>
								<div slot="topbar" @click.stop="onCloseCollection(item)" class="closeCollection">取消收藏</div>
							</ProductListItem> -->
            </div>
          </div>
        </div>
      </template>
    </iMineTemplate>
    <!-- 对话框 -->
    <iDialog ref="iDialogref" :msg="dialogMsg" confirm-btn-text="确认" cancel-btn-text="取消" :width="dialogMsg == '申请退款' ? '790px' : '560px'" @confirm="confirmDialog">
      <template #bottom>
        <div v-if="dialogMsg == '申请退款'">
          <div class="f18 c222 text-left" style="padding: 0 100px;">
            可退款金额：
            <span class="f18 cFF3939 fw600 ml5">¥ 192383.08</span>
          </div>
          <div style="padding: 15px 100px 30px;">
            <van-notice-bar wrapable :scrollable="false" color="#D3691F" background="#FFF6D8" class="cBABABA pl15 pr15 text-left f14 mt10">
              <van-icon :name="require('@/assets/mine/note.png')" size="20px" class="mr5" style="position: relative; top: 5px;" />
              注：申请退款后，平台将在1-2个工作日审核。退款金额将原路退回至您付款账户中。
            </van-notice-bar>
          </div>
        </div>
      </template>
    </iDialog>
    <!-- 申请开票弹框 -->
    <van-overlay :show="iApplyInvoice" z-index="5" @click="iApplyInvoice = false">
      <div class="wrapper" @click.stop><ApplyInvoiceForm ref="iApplyInvoice" isdialog @cancel="handleCancelInvoice" @confirm="handleConfirmInvoice" /></div>
    </van-overlay>
    <!-- 查看物流弹框 -->
    <van-overlay :show="iViewLogistics" z-index="5" @click="iViewLogistics = false">
      <div class="wrapper logistics" @click.stop><ViewLogistics ref="iViewLogistics" @cancel="closeViewLogistics" /></div>
    </van-overlay>
    <!-- 查看发票弹框 -->
    <van-overlay :show="ilookApplyInvoice" z-index="5" @click="ilookApplyInvoice = false">
      <div class="wrapper" @click.stop><ApplyInvoiceForm ref="ilookApplyInvoice" isdialog is-read-only @cancel="handleCancellookInvoice" /></div>
    </van-overlay>
  </div>
</template>

<script>
import { LinkTypeCode } from '@/dictionary/base.js'
import iProductDetail from '@/components/ProductDetail'
import iDialog from '@/components/iDialog'
import { BaseMixin } from '@/mixins/BaseMixin'
import iOrderList from '@/components/iOrderList'
import qs from 'qs'
export default {
  name: 'Mine',
  components: {
    iOrderList,
    iDialog,
    iProductDetail
  },
  mixins: [BaseMixin],
  data() {
    return {
      LinkTypeCode,
      pageTitle: ['我的账户', '个人中心'],
      activedParentKey: 1,
      activedKey: 11,
      CustomerInfo: null,
      CouponCount: null,
      MyFavouriteCount: null,
      PurchasedGoodsCount: null,
      CustomerInfoTestData: {
        EmployeeTypeName: '专属客服',
        Name: '测试',
        Phone: '139800000000'
      },
      CustomerService: null,
      CustomerBusiness: null,
      urls: {
        // 根据联系人获取客户信息
        getCustomerInfo: '/api_customers/Customer/GetCustomerEmployee',
        // 获取客户信息
        getCustomerContactDetail: '/api_customers/Customer/CustomerContactDetail',
        // 我的优惠券
        getCouponCount: '/api_coupon/Coupon/GetMyCoupons',
        // 我的收藏

        getMyFavouriteCount: '/api_customer/CustomerCollect/List?enumCollectType=1',
        // 常购商品
        getPurchasedGoods: '/api_order/Orders/GetPurchasedGoods'
      },
      orderDataList: [],
      iViewLogistics: false,
      iApplyInvoice: false,
      ilookApplyInvoice: false,
      dialogMsg: '',
      cDataList: []
    }
  },
  created() {},
  mounted() {
    this.onRefresh()
  },
  methods: {
    async onRefresh() {
      // 获取客户信息
      await this.getCustomerInfo()
      // 获取客户 服务业务员或者客服
      this.getCustomerEmployee()
      // 获取优惠券统计
      this.getCouponCount()
      // 获取常购商品
      this.getPurchasedGoods()
      this.getOrderData()
      // 我的收藏
      this.getMyFavouriteCount()
    },
    // 获取客户信息
    async getCustomerInfo() {
      this.$hys.openLoading()
      const res = await this.getAction(this.urls.getCustomerContactDetail)
      this.$hys.clearLoading()
      if (res.IsSuccess && res.Data) {
        this.CustomerInfo = res.Data
        this.auth.setCustomerId(this.CustomerInfo ? this.CustomerInfo.CustomerId : null)
        this.auth.setCustomerInfo(this.CustomerInfo ? this.CustomerInfo : null)
        this.$store.commit('_setIsSubAccount', res.Data.IsSub || false)
      } else {
        this.$toast({ position: 'bottom', message: res.Msg })
      }
    },
    // 获取客户 服务业务员或者客服
    async getCustomerEmployee() {
      const res = await this.getAction(this.urls.getCustomerInfo)
      if (res.IsSuccess && res.Data) {
        const result = res.Data.filter(tag => tag.EmployeeType == 1 || tag.EmployeeType == 2 || tag.EmployeeType == 3)
        this.CustomerService = result.find(tag => tag.EmployeeType == 1)
        this.CustomerBusiness = result.find(tag => tag.EmployeeType == 2)
        this.CustomerService = this.CustomerService ? this.CustomerService : this.CustomerInfoTestData
        this.CustomerBusiness = this.CustomerBusiness ? this.CustomerBusiness : this.CustomerInfoTestData
      } else {
        this.$toast({ position: 'bottom', message: res.Msg })
      }
    },
    // 获取优惠券统计
    async getCouponCount() {
      const res = await this.getAction(this.urls.getCouponCount, {
        enumCollectType: 1,
        pageNo: 1,
        pageSize: 10
      })
      if (res.IsSuccess && res.Data) {
        this.CouponCount = res.Count
      } else {
        this.$toast({ position: 'bottom', message: res.Msg })
      }
    },
    // 我的收藏
    async getMyFavouriteCount() {
      const res = await this.getAction(this.urls.getMyFavouriteCount, {
        pageNo: 1,
        pageSize: 4
      })
      if (res.IsSuccess && res.Data) {
        this.MyFavouriteCount = res.Count
        const dataArr = []
        res.Data.map(item => {
          const tags = []
          const SalesPromotionRules =
						item.OutBCommodityDto && item.OutBCommodityDto.SalesPromotions.length ? item.OutBCommodityDto.SalesPromotions[0].SalesPromotionRules : null
          if (
            SalesPromotionRules &&
						SalesPromotionRules[0].SalesPromotionRuleFullPresents &&
						SalesPromotionRules &&
						SalesPromotionRules[0].SalesPromotionRuleFullPresents.length
          ) { tags.push('满赠') }
          // item.CommodityListProperties //
          const PriceLimit = (item.OutBCommodityDto && item.OutBCommodityDto.PriceLimit) || 0
          const PriceActivity = (item.OutBCommodityDto && item.OutBCommodityDto.PriceActivity) || 0
          let differencePrice = 0
          if (PriceLimit && (!PriceActivity || PriceActivity >= PriceLimit)) {
            differencePrice = Number(item.CollectionPrice - PriceLimit)
          } else if ((PriceLimit && PriceActivity && PriceActivity <= PriceLimit) || PriceActivity) {
            differencePrice = Number(item.CollectionPrice - PriceActivity)
          } else {
            differencePrice = Number(item.CollectionPrice - PriceLimit)
          }
          const l = {
            checkBoxShow: false,
            checked: false,
            cId: item.Id,
            CollectingBusinessId: item.CollectingBusinessId,
            productId: item.OutBCommodityDto && item.OutBCommodityDto.Id,
            img: item.OutBCommodityDto && item.OutBCommodityDto.Logo,
            name: item.OutBCommodityDto && this._showProductTitle(item.OutBCommodityDto.SkuName, item.OutBCommodityDto.OperationName),
            Specifications: item.OutBCommodityDto && item.OutBCommodityDto.SpecificationsName,
            PriceLimit: PriceLimit,
            PriceActivity: PriceActivity,
            RetailPrice: item.OutBCommodityDto && item.OutBCommodityDto.RetailPrice,
            tag: tags,
            SalesPromotionRules: item.OutBCommodityDto && item.OutBCommodityDto.SalesPromotions ? item.OutBCommodityDto.SalesPromotions.SalesPromotionRules : [],
            ...item.OutBCommodityDto,
            Stock: item.Stock,
            IsSoldOut: item.OutBCommodityDto && !item.OutBCommodityDto.IsPutaway,
            differencePrice: differencePrice,
            ArrivalNotice: item.ArrivalNotice,
            EstimatedTime: item.OutBCommodityDto && item.OutBCommodityDto.EstimatedTime
          }
          dataArr.push(l)
        })
        this.cDataList = dataArr
      } else {
        this.$toast({ position: 'bottom', message: res.Msg })
      }
    },
    async onCloseCollection(pro) {
      const params = { ids: pro.cId }
      const res = await this.deleteAction('/api_customer/CustomerCollect/PhysicalDeleteBatch', {
        params: params,
        paramsSerializer: params => {
          return qs.stringify(params, { indices: false })
        }
      })
      if (!res.IsSuccess) {
        this.$toast({ position: 'bottom', message: res.Msg })
        return
      }
      this.getMyFavouriteCount()
    },
    // 商品详情
    showProduct(product) {
      this.$router.push({
        name: LinkTypeCode.ProductDetails,
        query: { goodsId: product.Id || '' }
      })
    },
    // getPurchasedGoods
    async getPurchasedGoods() {
      const res = await this.getAction(this.urls.getPurchasedGoods, {
        pageNo: 1,
        pageSize: 10
      })
      if (res.IsSuccess && res.Data) {
        this.PurchasedGoodsCount = res.Count
      } else {
        this.$toast({ position: 'bottom', message: res.Msg })
      }
    },

    // 获取订单数据
    async getOrderData() {
      const orderState = ''
      const orderPaymentState = ''
      const orderLogisticsState = ''
      this.$hys.openLoading()
      const res = await this.getAction('/api_order/Orders/List', {
        keyword: '',
        orderState: orderState,
        orderPaymentState: orderPaymentState,
        orderLogisticsState: orderLogisticsState,
        pageNo: 1,
        pageSize: 2
      })
      this.$hys.clearLoading()
      if (res.IsSuccess) {
        const dataArr = []
        if (res.Data) {
          res.Data.map(item => {
            let statusName = ''

            if (item.OrderState == 1) {
              if (item.OrderPaymentState == 1 || item.OrderPaymentState == 2 || item.OrderPaymentState == 7) {
                statusName = '待付款'
              } else if (item.OrderLogisticsState == 6) {
                statusName = '待发货'
              } else if (item.OrderLogisticsState == 3) {
                statusName = '已发货'
              } else if (item.OrderLogisticsState == 5) {
                statusName = '已收货'
              }
            } else if (item.OrderState == 2 && item.OrderLogisticsState == 5) {
              statusName = '已收货'
            } else if (item.OrderState == 3) {
              statusName = '已关闭'
            }
            if (this.orderDataList.findIndex(tag => tag.Id == item.Id) == -1) {
              const l = {
                ...item,
                status: statusName
              }
              dataArr.push(l)
            }
          })
        }
        this.orderDataList = this.orderDataList.concat(dataArr)
      } else {
        this.$toast({ position: 'bottom', message: res.Msg })
      }
    },
    // 查看发票
    handleCancellookInvoice() {
      this.ilookApplyInvoice = false
    },
    lookApplyInvoice(id) {
      this.ilookApplyInvoice = true
      this.$refs.ilookApplyInvoice.setApplyInvoiceId(id)
    },
    // 查看物流
    goViewLogistics(id) {
      this.iViewLogistics = true
      this.$refs.iViewLogistics.init(id)
    },
    closeViewLogistics() {
      this.iViewLogistics = false
    },
    // 申请开票
    goApplyInvoice(id) {
      this.iApplyInvoice = true
      this.$refs.iApplyInvoice.setApplyInvoiceId(id)
    },
    // 取消开票
    handleCancelInvoice() {
      this.iApplyInvoice = false
    },
    // 确认开票
    handleConfirmInvoice() {
      this.iApplyInvoice = false
      this.pageindex = 1
      this.getOrderData()
    },
    // 确认收货
    handleConfirmGoods(item) {
      this.dialogMsg = '是否确认收货？'
      this.$refs.iDialogref.iShow(item, 'receipt')
    },
    // 取消订单
    cancelOrder(item) {
      this.dialogMsg = '是否取消订单？'
      this.$refs.iDialogref.iShow(item, 'order')
    },
    // 申请退款
    cancelMoney(item) {
      this.dialogMsg = '申请退款'
      this.$refs.iDialogref.iShow(item, 'cancelMoney')
    },
    async confirmDialog(item, type) {
      // 申请退款  取消订单
      if (type == 'order' || type == 'cancelMoney') {
        this.$hys.openLoading()
        const res = await this.postAction('/api_order/Orders/CancelOrderV2', {
          OrderId: item.Id,
          OrderNo: item.OrderNo
        })
        this.$hys.clearLoading()
        if (!res.IsSuccess) {
          this.$toast({ position: 'bottom', message: res.Msg })
          return
        }
        this.$toast.success('取消成功')
      } else if (type == 'receipt') {
        this.$hys.openLoading()
        const res = await this.putAction('/api_order/Orders/ConfirmOrder?orderId=' + item.Id)
        this.$hys.clearLoading()
        if (!res.IsSuccess) {
          this.$toast({ position: 'bottom', message: res.Msg })
          return
        }
        this.$toast.success('收货成功')
      }
      await this.againLoad()
    },
    async againLoad() {
      this.pageindex = 1
      await this.getOrderData()
    },
    // 订单详情
    goDetails(id) {
      this.$router.push({
        path: 'OrderDetails',
        query: {
          orderId: id
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.memberCenter {
  float: left;
  overflow: hidden;
  margin-bottom: 20px;
  margin-left: 20px;
  border-radius: 2px;
  width: calc(100% - 20px);
  height: 260px;
  font-size: 14px;
  text-align: center;

  .top {
    //display: none;
    position: absolute;
    border-radius: 2px;
    width: 260px;
    height: 260px;
    background: #62A6FD;
    background-size: 100% 100%;
    box-shadow: 8px 2px 9px 0 rgba(188, 188, 188, .5);
    background-image: url('../../assets/mine/gerenzhongxin-bg.png');

    .headimg {
      border: 2px solid rgba(255, 255, 255, 1);
      width: 60px;
      height: 60px;
      background: rgba(222, 244, 254, 1);
      // background-image: url(@/assets/login/normal.png);
      background-size: cover;
      box-shadow: 0 2px 6px 0 rgba(12, 70, 145, 1);
    }

    .headtag {
      position: absolute;
      top: 85px;
      right: 100px;
      border-radius: 12px;
      width: 60px;
      height: 20px;
      // box-shadow: 0px 2px 4px 0px #CEE3FF;
    }

    .headtag_success {
      background: url('../../assets/mine/success.png') no-repeat center;
      background-size: cover;
    }

    .headtag_warning {
      background: url('../../assets/mine/warning.png') no-repeat center;
      background-size: cover;
    }

    .headtag_error {
      background: url('../../assets/mine/error.png') no-repeat center;
      background-size: cover;
    }

    .headtag_waiting {
      background: url('../../assets/mine/waiting.png') no-repeat center;
      background-size: cover;
    }

    .username {
      margin: 20px auto;
      border: 0 solid blue;
      font-size: 18px;
      font-weight: 600;
      color: rgba(255, 255, 255, 1);
      line-height: 25px;
    }

    .service {
      //opacity: 0.3;
      border: 1px solid rgba(255, 255, 255, 0);
      border-radius: 2px;
      width: 240px;
      height: 68px;
      color: white;
      background: rgba(255, 255, 255, .3);

      .kf1 {
        border-radius: 1px;
        width: 60px;
        height: 18px;
        background: linear-gradient(318deg, rgba(119, 153, 255, 1) 0%, rgba(83, 111, 238, 1) 100%);
      }

      .kf2 {
        border-radius: 1px;
        width: 60px;
        height: 18px;
        background: linear-gradient(313deg, rgba(85, 159, 255, 1) 0%, rgba(17, 126, 232, 1) 100%);
      }
    }
  }

  .bottom {
    top: 0;
    bottom: 0;
    float: right;
    margin: auto;
    border: 1px solid rgba(232, 232, 232, 1);
    border-radius: 1px;
    width: 100%;
    height: 206px;
    background: white;

    .ti {
      // width: 56px;
      height: 20px;
      font-size: 14px;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      line-height: 20px;
    }

    span {
      width: 99px;
      height: 29px;
      font-size: 36px;
      font-weight: bold;
      color: rgba(255, 133, 28, 1);
      line-height: 29px;
    }

    .blist {
      padding-top: 20px;

      span {
        width: 56px;
        height: 20px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(153, 153, 153, 1);
        line-height: 20px;
      }

      h {
        width: 21px;
        height: 29px;
        font-size: 24px;
        font-weight: 900;
        color: rgba(51, 51, 51, 1);
        line-height: 29px;
      }
    }
  }
}

.circle {
  right: 0;
  left: 0;
  margin: auto;
  border-radius: 50%;
}

.middle {
  right: 0;
  left: 0;
  margin: auto;
}

.v-middle {
  top: 0;
  bottom: 0;
  margin: auto;
}

.mt70 {
  margin-top: 70px;
}

.mt30 {
  margin-top: 30px;
}

.f12 {
  font-size: 12px;
}

.c222i {
  color: #222222 !important;
}

.mr6 {
  margin-right: 6px;
}

.order-list {
  border: 1px solid rgba(232, 232, 232, 1);
  border-radius: 2px;
  width: 100%;
}

.pb0 {
  padding-bottom: 0;
}

.mycollection {
  .goods {
    display: flex;
    padding: 10px;
    padding-bottom: 20px;
    flex-wrap: wrap;

    .goods-cell {
      padding: 5px;
      width: 25%;
    }

    .goods-b {
      position: relative;
      border: 1px solid #E8E8E8;
    }

    .goods-b:hover .closeCollection {
      display: block;
    }

    #goods-item {
      margin-top: 20px;
      margin-left: 20px;
      border: 1px solid rgba(232, 232, 232, 1);
      border-radius: 2px;
    }
  }

  .closeCollection {
    position: absolute;
    z-index: 1;
    display: none;
    border-radius: 1px;
    width: 100%;
    height: 32px;
    font-size: 14px;
    text-align: center;
    color: #FFFFFF;
    background: rgba(0, 0, 0, .41);
    box-shadow: 0 2px 11px 0 rgba(219, 219, 219, 1);
    line-height: 32px;
    cursor: pointer;
  }
}

/deep/.van-overlay {
  .wrapper {
    margin: 5% auto;
    max-width: 1200px;
  }

  .wrapper.logistics {
    width: 960px;
  }
}
</style>
